import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['You are a registered dietitian or active nutrition professional', 'You want to practice with more structure, clinical confidence, and precision', 'You want a ready-to-use system, not more content to study', 'You want to upgrade your consultation quality without years of additional study', 'You work in-person, virtually, or both', 'You want your practice to look, feel, and perform at a premium level'];
const notForYou = ['You are looking for a video course or academic certification', 'You expect someone to script every single patient interaction for you', 'You are not willing to invest in organizing and upgrading your practice', 'You want results without making any changes to how you currently work'];
export function AudienceSection() {
  return <section className="w-full bg-off-white px-5 py-12 sm:py-20" data-id="element-10" data-mp="3copknq5xxnt8">
      <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2" data-id="element-11" data-mp="3holq7tuadnaw">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl border border-sage/20 bg-[#F0F7ED] p-6 sm:p-8" data-id="element-12" data-mp="14bc4tckfc661">
          <h3 className="mb-6 text-lg font-bold text-dark-green sm:text-xl" data-id="element-13" data-mp="qk7cywnasi69">
            ✅ This system is for you if...
          </h3>
          <ul className="space-y-4" data-id="element-14" data-mp="llmbktwb7sg8">
            {forYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-15" data-mp="gkymwevjznp6">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage/20 text-dark-green" data-id="element-16" data-mp="gnkqy4j8jl2n">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-17" data-mp="7lbl3rywwfvl" />
                </span>
                <span className="text-sm leading-relaxed text-slate/80" data-id="element-18" data-mp="260o7mctrze18">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="rounded-2xl border border-red-100 bg-[#FFF5F5] p-6 sm:p-8" data-id="element-19" data-mp="21z2tko5i8tpg">
          <h3 className="mb-6 text-lg font-bold text-slate sm:text-xl" data-id="element-20" data-mp="3mesj2f0uva4h">❌ This is NOT for you if...</h3>
          <ul className="space-y-4" data-id="element-21" data-mp="i2drjgcfxpd0">
            {notForYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-22" data-mp="i2wxdyotgnao">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-23" data-mp="n1qee13bawfl">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-24" data-mp="9177ixal1wf0" />
                </span>
                <span className="text-sm leading-relaxed text-slate/80" data-id="element-25" data-mp="dzh33907yz15">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}